import React from 'react';
import { Container, Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

function Layout() {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #f8f9fa, #e9ecef)',
        backgroundAttachment: 'fixed',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '35vh',
          background: 'linear-gradient(135deg, #2e7d32, #81c784)',
          zIndex: 0,
          pointerEvents: 'none',
        }
      }}
    >
      <Navbar />
      <Container 
        maxWidth="md" 
        sx={{ 
          mt: { xs: 10, sm: 8 },
          mb: 6, 
          flex: 1,
          zIndex: 1,
          position: 'relative'
        }}
      >
        <Outlet />
      </Container>
      <Footer />
    </Box>
  );
}

export default Layout; 